import React from 'react';
import { translateService } from "../../services/TranslateService";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InfoIcon from '@mui/icons-material/Info';
import styles from './VehicleSearch.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/css/effect-fade';

interface OneWayFirstViewProps {
    rootUrl: string;
    onQuickSearch: (pickupCity: string, returnCity: string) => void;
}

const getCardData = (rootUrl: string) => {
    return [
        {
            img: `${rootUrl}/assets/one-way-default-imgs/Oulu 600x300.jpg`,
            cities: ['Helsinki', 'Oulu'],
            directionalImg: `${rootUrl}/assets/icons/new/search/oneway-bidirectional-icon-2.png`,
            price: '249€'
        },
        {
            img: `${rootUrl}/assets/one-way-default-imgs/Tampere 600x300.jpg`,
            cities: ['Helsinki', 'Tampere'],
            directionalImg: `${rootUrl}/assets/icons/new/search/oneway-bidirectional-icon-2.png`,
            price: '144€'
        },
        {
            img: `${rootUrl}/assets/one-way-default-imgs/Rovaniemi 600x300.jpg`,
            cities: ['Tampere', 'Oulu'],
            directionalImg: `${rootUrl}/assets/icons/new/search/oneway-bidirectional-icon-2.png`,
            price: '212€'
        },
        {
            img: `${rootUrl}/assets/one-way-default-imgs/Turku 600x300.jpg`,
            cities: ['Helsinki', 'Turku'],
            directionalImg: `${rootUrl}/assets/icons/new/search/oneway-bidirectional-icon-2.png`,
            price: '151€'
        },
        {
            img: `${rootUrl}/assets/one-way-default-imgs/Jyväskylä 600x300.jpg`,
            cities: ['Vantaa', 'Jyväskylä'],
            directionalImg: `${rootUrl}/assets/icons/new/search/oneway-bidirectional-icon-2.png`,
            price: '122€'
        }
    ];
}

export const OneWayFirstView2: React.FC<OneWayFirstViewProps> = ({rootUrl, onQuickSearch}) => {
    const cardData = getCardData(rootUrl);
    return (
        <div className={styles['oneWayInfoSection']} >
            <div className={styles['centerForDefaultScreen']}>
                <div className={styles['oneWaySegment1']}>
                    <div className={styles['oneWayInfoSegment1Rows']}>
                        <CheckBoxIcon className={styles['oneWayInfoCheckbox']}/>
                        <span className={styles['oneWayInfoText']}>
                        {translateService.translate('oneWayDefaultScreen.firstSegmentText1')}
                    </span>
                    </div>
                    <div className={styles['oneWayInfoSegment1Rows']}>
                        <CheckBoxIcon className={styles['oneWayInfoCheckbox']} />
                        <span className={styles['oneWayInfoText']}>
                        {translateService.translate('oneWayDefaultScreen.firstSegmentText2')}
                    </span>
                    </div>
                    <div className={styles['oneWayInfoSegment1Rows']}><CheckBoxIcon className={styles['oneWayInfoCheckbox']}/>
                        <span className={styles['oneWayInfoText']}>
                        {translateService.translate('oneWayDefaultScreen.firstSegmentText3')}
                    </span>
                    </div>
                    <div className={styles['oneWayInfoSegment1Rows']}><CheckBoxIcon className={styles['oneWayInfoCheckbox']}/>
                        <span className={styles['oneWayInfoText']}>
                        {translateService.translate('oneWayDefaultScreen.firstSegmentText4')}
                    </span>
                    </div>
                </div>
                <br/>
                <a className={styles['oneWayInfoBtn']} href="https://www.24rent.fi/oneway-auton-edut/">
                    {translateService.translate('oneWayDefaultScreen.firstSegmentBtn')}
                </a>
                <br/>
            </div>
            <h2 className={styles['oneWayDefaultSwiperHeading']}>
                {translateService.translate('oneWayDefaultScreen.secondSegmentHeading')}
            </h2>
            <div>
                <Swiper
                        spaceBetween="10"
                        slidesPerView={5}
                        pagination={false}
                        scrollbar={{ draggable: true }}
                        navigation={cardData.length > 1}
                        breakpoints={{
                            100: { slidesPerView: 1, spaceBetween: 5 },
                            450: { slidesPerView: 2, spaceBetween: 5 },
                            640: { slidesPerView: 3, spaceBetween: 5 },
                            900: { slidesPerView: 4, spaceBetween: 5 },
                            1200: { slidesPerView: 5, spaceBetween: 5 }
                        }}>
                        {cardData.map((card, idx) => (
                            <SwiperSlide key={idx} >
                                <div className={styles['oneWayDefaultSwiperCard']}>
                                    <img src={card.img} alt=""
                                         className={styles['oneWayDefaultSwiperCardImg']} />
                                    <div className={styles['oneWayInfoScreenTbRows']}>
                                        <div className={styles['oneWayDefaultSwiperCities']}> {card.cities[0]}
                                            <img className={styles['oneWayTbRowDirectionalImg']} src={card.directionalImg} alt="" />
                                            {card.cities[1]}</div>

                                        <div className={styles['oneWayInfoScreenTbPrice']}>
                                            <div className={styles['oneWayDefaultSwiperPriceLabel']}>
                                                <span> {translateService.translate('oneWayDefaultScreen.averagePrice')} </span>
                                                <div>{card.price}</div>
                                            </div>
                                            <div>
                                                <button onClick={() => onQuickSearch(card.cities[0], card.cities[1])}
                                                        className={`btn btn-primary btn-all ${styles['oneWayInfoScreenTbBtn']}`}>
                                                    {">"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    </div>


            <div className={styles['centerForDefaultScreen']}>
                <div className={styles['oneWayInfoBox']}>
                    <InfoIcon /> {translateService.translate('oneWayDefaultScreen.secondSegmentText11')}
                </div>
            </div>

        </div>
    );
}

export default OneWayFirstView2;